import {handleActions} from 'redux-actions';
import {createThunkActionCreator} from 'utils/redux/createThunkActionCreator';
import * as thunkActionConstants from 'utils/redux/thunkActionConstants';
import * as documents from 'services/api/documents';

const documentTypeToPath = {
  'privacy-policy' : '/generate/PRIVACY_POLICY',
  'terms-of-use' : '/generate/TERMS_OF_USE',
  'privacy-agreement' : '/generate/PRIVACY_AGREEMENT',
  'digital-wallet-tc' : '/generate/static/DIGITAL_WALLET_TC',
  'recurring-payment-authorization' : '/generate/RECURRING_PAYMENT_AUTHORIZATION',
  'california-privacy-choices' : '/generate/PRIVACY_POLICY_CALIFORNIA',
  'glba' : '/generate/GLBA',
  'glba-tab' : '/generate/GLBA_TAB',
  'loan-payment-disclosure': '/generate/loan-payment-disclosure'
};

const reducerMap = {};

/**
 * @function documentFetch
 * @param {string} document
 * @return {Function}
 */
export const DOCUMENT_FETCH = 'PURCHASES/DOCUMENT_FETCH';
export const documentFetch = createThunkActionCreator(DOCUMENT_FETCH, (documentType, externalId) => {
  return documents.getDocument(documentTypeToPath[documentType], externalId);
});
reducerMap[DOCUMENT_FETCH] = (state, action) => {
  const {payload, args, ...rest} = action;
  if (action.status === thunkActionConstants.ACTION_STATUS_PENDING) {
    const documentType = args && args.length ? args[0] : false;
    return {...rest, documentType};
  }
  return {...state, ...rest, document: payload};
};





/**
 * @function setAutoPay
 * @return {Function}
 */
export const CARD_GET_PDF_STATEMENT = 'CARD/GET_PDF_STATEMENT';
export const getPdfStatement = createThunkActionCreator(CARD_GET_PDF_STATEMENT,  (date, isStatementOnly, isSupplementalDoc) => {
  return  documents.getPdfStatement(date, isStatementOnly, isSupplementalDoc);
});

reducerMap[CARD_GET_PDF_STATEMENT] = (state, action) => {
  const { payload, ...rest } = action;
  // return {...state,...payload , ...rest};
   switch (rest.status) {
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {...state, ...rest, pdfStatement: { ...payload }};
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {...state, ...action, pdfStatement: {}};

    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state, ...action, pdfStatement: {...state.pdfStatement, ...rest, error: action.error}
      };
  }
};

export const CARD_GET_HTML_STATEMENT = 'CARD/GET_HTML_STATEMENT';
export const getHtmlStatement = createThunkActionCreator(CARD_GET_HTML_STATEMENT, (date) => {
  return documents.getHtmlStatement(date);
});

reducerMap[CARD_GET_HTML_STATEMENT] = (state, action) => {
  const { payload, ...rest } = action;
  const statement = payload && payload.statementPhotosDTO || null;
  switch (rest.status) {
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {...state, ...rest, htmlStatement: statement};
    case thunkActionConstants.ACTION_STATUS_PENDING:
      return {...state, ...action, htmlStatement: {}};

    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {
        ...state, ...action, htmlStatement: {...state.htmlStatement, ...rest, error: action.error}
      };
  }
};

export const reducer = handleActions(reducerMap, {
  document: {}
});



// WEBPACK FOOTER //
// ./src/pdf/redux.js